import { render, staticRenderFns } from "./NouvelleEtude.vue?vue&type=template&id=f054100a&scoped=true"
import script from "./NouvelleEtude.vue?vue&type=script&lang=js"
export * from "./NouvelleEtude.vue?vue&type=script&lang=js"
import style0 from "./NouvelleEtude.vue?vue&type=style&index=0&id=f054100a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f054100a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f054100a')) {
      api.createRecord('f054100a', component.options)
    } else {
      api.reload('f054100a', component.options)
    }
    module.hot.accept("./NouvelleEtude.vue?vue&type=template&id=f054100a&scoped=true", function () {
      api.rerender('f054100a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NouvelleEtude.vue"
export default component.exports